/*
 * Betaalicoontjes op de PDP, Figma node 1136:1721.
 *
 * De rij komt uit de winkelinstellingen, dus hoeveel badges er zijn ligt niet
 * vast. Passen ze niet op één regel, dan lopen ze in het ontwerp niet door op
 * een tweede regel: er staan er zoveel als passen en een "+n" vangt de rest op.
 *
 * Hoeveel er passen hangt van de schermbreedte af (een 320px-toestel haalt er
 * minder dan een 430px-toestel), dus dat wordt hier gemeten in plaats van
 * vastgelegd in CSS. Dat geldt op desktop net zo goed als op mobiel.
 *
 * Zonder JS blijft de teller verborgen en wikkelen de badges gewoon door, dus
 * de rij blijft compleet.
 */
(function () {
  function layout(list) {
    var items = Array.prototype.slice.call(
      list.querySelectorAll("[data-payment-badge]"),
    );
    var more = list.querySelector("[data-payment-badge-more]");
    if (!items.length || !more) return;

    /* Eerst alles terug in beeld: anders meet de volgende ronde de uitkomst
       van de vorige en krimpt de rij bij elke resize verder. */
    items.forEach(function (item) {
      item.hidden = false;
    });
    more.hidden = false;
    var moreWidth = more.getBoundingClientRect().width;
    more.hidden = true;

    var styles = window.getComputedStyle(list);
    var gap = parseFloat(styles.columnGap) || 0;
    var available =
      list.clientWidth -
      (parseFloat(styles.paddingLeft) || 0) -
      (parseFloat(styles.paddingRight) || 0);
    var itemWidth = items[0].getBoundingClientRect().width;
    if (!itemWidth || !available) return;

    /* Past alles, dan hoeft de teller er niet bij. */
    if (Math.floor((available + gap) / (itemWidth + gap)) >= items.length) {
      return;
    }

    /* De teller neemt zelf ook een plek in: n badges plus n tussenruimtes
       plus de teller moeten binnen de beschikbare breedte blijven. */
    var visible = Math.floor((available - moreWidth) / (itemWidth + gap));
    if (visible < 1) visible = 1;
    if (visible >= items.length) return;

    items.slice(visible).forEach(function (item) {
      item.hidden = true;
    });

    var remaining = items.length - visible;
    var count = more.querySelector("[data-payment-badge-more-count]") || more;
    count.textContent = "+" + remaining;

    var template = more.getAttribute("data-label-template");
    if (template) {
      more.setAttribute("aria-label", template.replace("[count]", remaining));
    }
    more.hidden = false;
  }

  function layoutAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll("[data-payment-badges]"),
      layout,
    );
  }

  var frame = null;
  function scheduleLayout() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      layoutAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      layoutAll();
    });
  } else {
    layoutAll();
  }

  window.addEventListener("resize", scheduleLayout);

  /* De theme editor rendert de sectie opnieuw; dan staat er een verse,
     ongemeten rij. */
  document.addEventListener("shopify:section:load", function (event) {
    layoutAll(event.target);
  });
})();
